export default [
    "24 24",
    '<path d="M12 20V4M12 4L6 10M12 4L18 10" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

